// Mega nav

document.addEventListener("DOMContentLoaded", function () {
  var megaMenuItem = document.getElementsByClassName("mega-menu__item--parent");
  var megaMenu = document.getElementsByClassName("mega-menu__sub-menu");
  var menuItem = document.getElementsByClassName("mega-menu__item--default");
  var menuParent = document.querySelector(".site-header__nav--desktop");
  for (var i = 0; i < megaMenuItem.length; i++) {
    megaMenuItem[i].addEventListener("mouseenter", function () {
      for (var a = 0; a < megaMenuItem.length; a++) {
        if (
          megaMenuItem[a].classList.contains("mega-menu__item--parent__hover")
        ) {
          megaMenuItem[a].classList.remove("mega-menu__item--parent__hover");
        }
      }
      this.classList.add("mega-menu__item--parent__hover");
      menuParent.classList.add("site-header__nav--desktop__hover");
    });
  }

  for (var i = 0; i < menuItem.length; i++) {
    menuItem[i].addEventListener("mouseenter", function () {
      for (var a = 0; a < megaMenuItem.length; a++) {
        if (
          megaMenuItem[a].classList.contains("mega-menu__item--parent__hover")
        ) {
          megaMenuItem[a].classList.remove("mega-menu__item--parent__hover");
        }
      }
    });
  }

  for (var i = 0; i < megaMenu.length; i++) {
    megaMenu[i].addEventListener("mouseleave", function () {
      this.parentElement.classList.remove("mega-menu__item--parent__hover");
      menuParent.classList.remove("site-header__nav--desktop__hover");
    });
  }

  document.addEventListener("mouseleave", function (event) {
    for (var a = 0; a < megaMenuItem.length; a++) {
      if (
        megaMenuItem[a].classList.contains("mega-menu__item--parent__hover")
      ) {
        megaMenuItem[a].classList.remove("mega-menu__item--parent__hover");
        menuParent.classList.remove("site-header__nav--desktop__hover");
      }
    }
  });
});
